/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoMfaVerify } from '../../models/dto-mfa-verify';
import { SessionResponse } from '../../models/session-response';

export interface IdentityControllerMfaVerify$Params {
      body: DtoMfaVerify
}

export function identityControllerMfaVerify(http: HttpClient, rootUrl: string, params: IdentityControllerMfaVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerMfaVerify.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: SessionResponse;
      }>;
    })
  );
}

identityControllerMfaVerify.PATH = '/identity/session/mfa';
